export default {
    'delete-message-reminder': 'Are you sure you want to delete this reminder?'
};
